// extracted by mini-css-extract-plugin
export default {"bottombar_right":"new-project-bottom-bar_bottombar_right__nBcKh"};